export default __webpack_public_path__ + "static/DAFAx-logo-white-1a0e91b000e1a0472952be544191946f.png";